import React from 'react'
import Input from '../../../../../../../../../Components/Input/Input'
import DashboardBatchesStore from '../../../Stores/DashboardBatchesStore'

function SearchBox() {
  const { query, setQuery } = DashboardBatchesStore.useContainer()

  return (
    <div className='searchBox'>
      <Input
        type='text'
        className='search'
        placeholder='Search Batches'
        value={query}
        onChange={(e) => {
          setQuery(e.target.value)
        }}
      />
    </div>
  )
}

export default SearchBox
